export default "__VITE_ASSET__woqkc6JI__"